import React, { useState } from 'react';
import { FloatingFocusManager, FloatingOverlay, useClick, useDismiss, useFloating, useInteractions, useRole, } from '@floating-ui/react';
// styles
import styles from './Modal.module.scss';
function Modal({ open: externalOpen, setOpen: externalSetOpen, children, closeOnEscape, closeOnOutsideClick, Content, contentProps, }) {
    const [internalOpen, setInternalOpen] = useState(false);
    const open = externalOpen !== null && externalOpen !== void 0 ? externalOpen : internalOpen;
    const setOpen = externalSetOpen !== null && externalSetOpen !== void 0 ? externalSetOpen : setInternalOpen;
    const { refs, context } = useFloating({
        open: open,
        onOpenChange: setOpen,
    });
    const click = useClick(context);
    const role = useRole(context);
    const dismiss = useDismiss(context, {
        outsidePressEvent: 'mousedown',
        enabled: closeOnOutsideClick,
        escapeKey: closeOnEscape,
    });
    // Merge all the interactions into prop getters
    const { getReferenceProps, getFloatingProps } = useInteractions([
        click,
        dismiss,
        role,
    ]);
    const closeModal = () => {
        setOpen(false);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", Object.assign({ ref: refs.setReference }, getReferenceProps()), children),
        open && (React.createElement(FloatingOverlay, { lockScroll: true, className: styles.overlay },
            React.createElement(FloatingFocusManager, { context: context, modal: true },
                React.createElement("div", Object.assign({ ref: refs.setFloating }, getFloatingProps(), { className: styles.containerWrapper }),
                    React.createElement(Content, Object.assign({}, contentProps, { close: closeModal }))))))));
}
export default Modal;
